export const messages = {
    login: "Login",
    chooseAPassword: "Kies een wachtwoord.",
    password: "Vul een wachtwoord in.",
    emailAddress: "Email address is verplicht.",
    fieldRequired: "Dit veld is verplicht.",
    fieldMax: "Maximum lengte is :max.",
    fieldMin: "Minimum lengte is :min.",
    fieldMaxNumber: "Maximum nummer is :max.",
    fieldMinNumber: "Minimum nummer is :min.",
    formError: "Er ging iets mis, controleer de ingevulde velden."
}
